// @flow
import React from "react";
import { Icon } from "@cld/icon";
import Layout from "@cld/list-item-layout";
import { KIND } from "../../data/consts";

type Props = {
   name: string,
   kind: string,
} ;

const KIND_ICONS = {
	[KIND.MY_DRIVE]: "googleDrive",
	[KIND.SHARED_WITH_ME]: "group",
	[KIND.SHARED_DRIVE]: "sharedDrive",
	[KIND.RECENT]: "recent",
	[KIND.STARRED]: "starred",
	[KIND.DRIVE]: "internalDrive",
};

const getIconName = ({ kind }) => KIND_ICONS[kind] || "folder";

const TreeNodeWithIcons = ({ name, kind }: Props) => (
	<Layout>
		<Icon name={getIconName({ kind })}/>
		<span>{name}</span>
	</Layout>
);

export default TreeNodeWithIcons;
